import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=618c6100&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=618c6100&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618c6100",
  null
  
)

export default component.exports